import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c370aa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-box" }
const _hoisted_2 = { class: "form-field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "请输入每条线路需要绑定的设备数", -1))
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "请选择需要绑定的设备", -1))
const _hoisted_6 = { class: "form-btn-group" }

import { inject, ref } from 'vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import SelectModelTable from '@/components/business/crud/common/SelectModelTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceSelect',
  setup(__props) {

const num = ref(1);

const options = ref([]);

const windowTool = inject<WindowTool | false>(WindowTool, false);

async function onSubmit() {
  if (windowTool) {
    windowTool.close({
      selected: options.value,
      num: num.value,
    });
  }
}

function onReset() {
  options.value = [];
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_sc_page = _resolveComponent("sc-page")!

  return (_openBlock(), _createBlock(_component_sc_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_a_input, {
            class: "input",
            type: "number",
            value: num.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((num).value = $event))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(SelectModelTable, {
            "module-name": "management",
            "controller-name": "device",
            "label-name": "name",
            "input-label": "",
            "hidden-fields": ['rule', 'selectedProxy', 'proxySetting'],
            modelValue: options.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options).value = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_sc_btn, {
          handler: onSubmit,
          text: "确定",
          type: "primary"
        }),
        _createVNode(_component_sc_btn, {
          handler: onReset,
          style: {"margin-left":"10px"},
          text: "重置"
        })
      ])
    ]),
    _: 1
  }))
}
}

})